// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import './assets/common.css'
import OfferGoldSoftPlugin from '@/plugins/offer-goldsoft'

// ❌ 你现在是：createApp(App).use(router).mount('#app').use(OfferGoldSoftPlugin)
// ✅ 正确：所有 .use() 都在 mount 之前
createApp(App)
  .use(router)
  .use(OfferGoldSoftPlugin, { name: 'OfferGoldSoftCard' })
  .mount('#app')
